import FormFieldViewCode from "components/FormFields/ViewCode";
import FormFieldViewText from "components/FormFields/ViewText";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerFooter from "ds/components/Drawer/Footer";
import DrawerFooterActions from "ds/components/Drawer/FooterActions";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerCancelButton from "ds/components/DrawerNew/CancelButton";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import { IntentResource } from "types/generated";

type IntentProjectResourceDetailsDrawerProps = {
  resource: IntentResource;
};

const IntentProjectResourceDetailsDrawer = createDrawer(
  ({ resource }: IntentProjectResourceDetailsDrawerProps) => {
    const hasState = !!resource.state && resource.state !== "null";

    return (
      <DrawerSimple>
        <DrawerHeader justify="between">
          <DrawerHeaderTitle title="Resource details" />
          <DrawerCloseIcon />
        </DrawerHeader>
        <DrawerBody gap="x-large">
          <FormFieldViewText label="Resource ID" value={resource.resourceID} withCopy noMargin />
          <FormFieldViewText
            label="Resource type"
            value={resource.resourceType}
            withCopy
            noMargin
          />
          <FormFieldViewText label="Provider" value={resource.provider} withCopy noMargin />
          <FormFieldViewCode
            label="State"
            code={hasState ? resource.state : "Not available"}
            language={hasState ? "json" : undefined}
            noMargin
          />
          <FormFieldViewCode
            label="Infrastructure as Code"
            code={resource.hcl}
            language="hcl"
            noMargin
          />
        </DrawerBody>

        <DrawerFooter>
          <DrawerFooterActions>
            <DrawerCancelButton text="Close" />
          </DrawerFooterActions>
        </DrawerFooter>
      </DrawerSimple>
    );
  }
);

export const showIntentProjectResourceDetailsDrawer = createDrawerTrigger(
  IntentProjectResourceDetailsDrawer
);
